import { render, staticRenderFns } from "./UpdateMake.vue?vue&type=template&id=1c5898dd&"
import script from "./UpdateMake.vue?vue&type=script&lang=js&"
export * from "./UpdateMake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports